<svg
  viewBox="0 0 512 512"
  xml:space="preserve"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="m 486.77821,421.73 -65.045,65.045 c -12.024,12.024 -31.521,12.024 -43.546,0 l -188.71,-188.71 108.59,-108.59 188.71,188.71 c 12.025,12.026 12.025,31.522 0,43.546 z"
    fill="#c6c5ca"
  />
  <path
    d="m 243.77221,243.77 -54.295,54.295 188.23,188.23 c 12.293,12.293 32.224,12.293 44.516,0 l 32.037,-32.037 -210.49,-210.49 z"
    fill="#9b9aa5"
  />
  <path
    d="m 307.00221,415.59 36.66,-71.94 71.931,-36.65 -117.531,-117.53 -108.59,108.59 z"
    fill="#9b9aa5"
  />
  <path
    fill="#797882"
    d="m 189.47221,298.06 117.53,117.53 36.66,-71.94 -99.89,-99.88 z"
  />
  <path
    d="m 296.16221,296.15 -101.23,198.66 a 31.48,31.48 0 0 1 -58.185,-5.204 L 1.3472144,40.566 A 31.479,31.479 0 0 1 40.572214,1.341 l 449.039996,135.4 a 31.48,31.48 0 0 1 5.204,58.185 l -198.66,101.23 z"
    fill="#31aaef"
  />
  <path
    d="m 9.2222144,9.221 a 31.477,31.477 0 0 0 -7.88,31.345 L 136.74221,489.606 a 31.48,31.48 0 0 0 58.185,5.204 L 296.15721,296.15 9.2272144,9.22 Z"
    fill="#005b9a"
  />
</svg>
